import { render, staticRenderFns } from "./EcosystemModulesToggle.vue?vue&type=template&id=466a4a06"
import script from "./EcosystemModulesToggle.vue?vue&type=script&lang=js"
export * from "./EcosystemModulesToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports